import {
    HttpErrorResponse,
    HttpEvent,
    HttpHandlerFn,
    HttpRequest,
} from '@angular/common/http';
import { inject } from '@angular/core';
import { Observable, catchError, throwError } from 'rxjs';
import { AuthService } from 'app/core/auth/auth.service';
import { AuthUtils } from 'app/core/auth/auth.utils';

const NO_AUTH_HEADER_URLS = [
    '/Auth/login',
    '/Auth/company-signup',
    '/Auth/company-signup/stream',
    '/hr/document-signing',
];

const NO_AUTO_SIGNOUT_ON_401_URLS = [
    '/Auth/login',
    '/Auth/logout',
    '/Auth/change-password',
    '/Auth/verify-password',
    '/Auth/company-signup',
    '/Auth/company-signup/stream',
    '/hr/document-signing',
];

export const authInterceptor = (
    req: HttpRequest<unknown>,
    next: HttpHandlerFn
): Observable<HttpEvent<unknown>> => {
    const authService = inject(AuthService);
    const isExcluded = NO_AUTH_HEADER_URLS.some(url => req.url.includes(url));
    let newReq = req;
    // FileUpload/single|multiple require Bearer (with CompanyId claim) when attaching to a document.
    if (
        !isExcluded &&
        authService.accessToken &&
        !AuthUtils.isTokenExpired(authService.accessToken)
    ) {
        newReq = req.clone({
            setHeaders: {
                Authorization: `Bearer ${authService.accessToken}`,
            },
        });
    }

    return next(newReq).pipe(
        catchError((error: HttpErrorResponse) => {
            if (error.status === 401) {
                const isAuthRequest = NO_AUTO_SIGNOUT_ON_401_URLS.some(url =>
                    req.url.includes(url)
                );
                if (isAuthRequest) {
                    return throwError(() => error);
                }
                authService.signOut(true).subscribe();
            }

            return throwError(() => error);
        })
    );
};
